import {useRef} from 'react';

import {secureRandomInt} from 'shared/utils/random';

export const useRandomBlueGenerator = () => {
    const colorsCacheRef = useRef<{[color: string]: string}>({});

    const generateBlueShade = () => {
        const h = 214;
        const s = secureRandomInt(60, 80);
        const l = secureRandomInt(40, 60);
        return `hsl(${h}, ${s}%, ${l}%)`;
    };

    const generate = (key?: string) => {
        if (!key) return generateBlueShade();
        if (!colorsCacheRef.current[key]) colorsCacheRef.current[key] = generateBlueShade();
        return colorsCacheRef.current[key];
    };

    return {generate};
};
